import * as React from 'react'

import { Text } from '~/components/text/Text'
import { styled } from '~/styled'

import { EmptyStateContext } from './EmptyState.context'

const StyledEmptyStateBody = styled(
  Text,
  {
    base: ['text-grey-800', 'font-normal'],
    variants: {
      size: {
        xs: ['mb-4', 'text-sm'],
        sm: ['mb-4', 'text-sm'],
        md: ['mb-4', 'text-sm'],
        lg: ['mb-6', 'text-md'],
        xl: ['mb-6', 'text-md']
      }
    }
  },
  { enabledResponsiveVariants: true }
)

type EmptyStateBodyProps = React.ComponentProps<typeof StyledEmptyStateBody>

export const EmptyStateBody = (props: EmptyStateBodyProps) => {
  const { size } = React.useContext(EmptyStateContext)
  return <StyledEmptyStateBody {...props} size={size} />
}
